import * as React from "react";

import { convertMsToMinSecString } from "~components/shared/card/AudioVideoCard";

import styles from "./PlayIconWithDuration.module.css";

export interface PlayIconWithDurationProps {
    duration?: number;
}

export default function PlayIconWithDuration({
    duration,
}: PlayIconWithDurationProps) {
    return (
        <div
            className={styles.playIconWithDuration}
            data-component="play-icon-with-duration"
        >
            <div className={styles.playIcon}>
                <svg
                    className={styles.icon}
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM16 27L28 20L16 13L16 27Z"
                        data-component="inner-circle"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M28 20L16 27L16 13L28 20Z"
                        data-component="icon"
                    />
                    <circle
                        cx="20"
                        cy="20"
                        r="19"
                        stroke="white"
                        strokeWidth="2"
                    />
                </svg>
            </div>
            {duration ? (
                <div className={styles.duration}>
                    {convertMsToMinSecString(duration)}
                </div>
            ) : undefined}
        </div>
    );
}
